import { handleResponse } from "utils/axios";
import { axiosInstance } from "./index";

const getAllSupportedChains = async () => {
  return await axiosInstance.get("/settings/chains").then(handleResponse);
};

const createSupportedChains = async (data) => {
  return await axiosInstance.post("/settings/chains", data).then(handleResponse);
};

const updateSupportedChains = async (data) => {
  return await axiosInstance.put("/settings/chains", data).then(handleResponse);
};

export { getAllSupportedChains, createSupportedChains, updateSupportedChains };
